var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _circle4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 60,
    viewBox: "0 0 134 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.1816,
    width: 21.8182,
    height: 5.45455,
    rx: 2.72727,
    fill: "#F0F5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.1816,
    y: 10.9092,
    width: 34.5455,
    height: 5.45455,
    rx: 2.72727,
    fill: "#F0F5FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.637,
    y: 1.81836,
    width: 9.09091,
    height: 5.45455,
    rx: 2.72727,
    fill: "#F0F5FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124.273,
    y: 25.4546,
    width: 9.09091,
    height: 5.45455,
    rx: 2.72727,
    fill: "#F0F5FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2734,
    y: 23.6362,
    width: 36.3636,
    height: 5.45455,
    rx: 2.72727,
    fill: "#F0F5FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2734,
    y: 36.3638,
    width: 27.2727,
    height: 5.45455,
    rx: 2.72727,
    fill: "#F0F5FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36.3638,
    width: 32.7273,
    height: 5.45455,
    rx: 2.72727,
    fill: "#F0F5FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.636719,
    y: 49.0908,
    width: 56.3636,
    height: 5.45455,
    rx: 2.72727,
    fill: "#F0F5FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.7282,
    cy: 10.9088,
    r: 3.63636,
    fill: "#F0F5FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.1823,
    cy: 47.2726,
    r: 3.63636,
    fill: "#F0F5FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.455,
    cy: 18.182,
    r: 1.81818,
    fill: "#F0F5FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.9096,
    cy: 34.5454,
    r: 25.4545,
    fill: "#F0F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1648 42.1602C62.6679 42.1602 62.1711 41.9772 61.7788 41.5849L57.5688 37.3748C56.8104 36.6165 56.8104 35.3613 57.5688 34.603C58.3271 33.8447 59.5823 33.8447 60.3406 34.603L63.1648 37.4271L73.0232 27.5688C73.7815 26.8104 75.0367 26.8104 75.795 27.5688C76.5534 28.3271 76.5534 29.5823 75.795 30.3406L64.5507 41.5849C64.1584 41.9772 63.6616 42.1602 63.1648 42.1602Z",
    fill: "#0A5EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.ff48833b71727f77f7efb476077a11f4.svg";
export { ForwardRef as ReactComponent };